

const heb: { [key: string]: string } = {
    userName:           'שם מלא',
    userEmail:          'כתובת דוא״ל',
    schoolName:         'שם בית הספר',
    city:               'שם הישוב',
    teacherName:        'שם המורה למתמטיקה',
    allowNotifications: 'האם ארצה לקבל מידע על פעילויות נוספות הקשורות ליישומטיקה?',
    arabic:             'דובר ערבית',
    hidonOtzarHaMeara:  'חידון אוצר המערה'
}


export default heb;